import { render } from "./NuvensAdmin.vue?vue&type=template&id=6c8f6637"
import script from "./NuvensAdmin.vue?vue&type=script&lang=js"
export * from "./NuvensAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__